import { createContext, useState, useEffect } from 'react';
import axios from '../axios-config';

export const OrganizationJobsContext = createContext<any>(null);

export function OrganizationJobsContextProvider({ children }: { children: React.ReactNode }) {
  const [organizationJobs, setOrganizationJobs] = useState<any[]>([]);
  
  const [organizationAssignments, setOrganizationAssignments] = useState<any[]>([]);

  const normalizeJobsResponse = (data: any): any[] => {
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object' && Array.isArray((data as any).jobs)) {
      return (data as any).jobs;
    }
    return [];
  };

  const normalizeAssignmentsResponse = (data: any): any[] => {
    if (Array.isArray(data)) return data;
    if (
      data &&
      typeof data === 'object' &&
      Array.isArray((data as any).assignments)
    ) {
      return (data as any).assignments;
    }
    return [];
  };

  const fetchOrganizationJobAssignments = async () => {
    try {
      const { data } = await axios.get('/api/OrganizationJobs/assignments');
      setOrganizationAssignments(normalizeAssignmentsResponse(data));
    } catch (error) {
      console.error("Error fetching organization assignments:", error);
    }
  };

  useEffect(() => {
    fetchOrganizationJobs();
    fetchOrganizationJobAssignments();
  }, []);

  const fetchOrganizationJobs = async () => {
    const { data } = await axios.get('/api/OrganizationJobs');
    const jobs = normalizeJobsResponse(data);
    setOrganizationJobs(jobs);
    return jobs;
  };

  const createOrganizationJob = async (payload: any) => {
    await axios.post('/api/OrganizationJobs', payload);
    await fetchOrganizationJobs();
  };

  const updateOrganizationJob = async (id: any, payload: any) => {
    await axios.put(`/api/OrganizationJobs/${id}`, payload);
    await fetchOrganizationJobs();
  };

  const deleteOrganizationJob = async (id: any) => {
    await axios.delete(`/api/OrganizationJobs/${id}`);
    await fetchOrganizationJobs();
  };

  return (
    <OrganizationJobsContext.Provider value={{
      fetchOrganizationJobs,
      organizationJobs,
      organizationAssignments,
      setOrganizationAssignments,
      fetchOrganizationJobAssignments,
      createOrganizationJob,
      updateOrganizationJob,
      deleteOrganizationJob
    }}>
      {children}
    </OrganizationJobsContext.Provider>
  );
};
